<header>
    <div class="header-left">
        <button
            mat-icon-button
            class="back-button"
            aria-label="Back"
            (click)="closeDialog()">
            <span class="icon-arrow-left"></span>
        </button>
        <h3>{{ data.title }}</h3>
    </div>
    <button
        mat-icon-button
        aria-label="Close"
        (click)="closeDialog()"
    >
        <span class="icon-close"></span>
    </button>
</header>

<div class="dialog-content">
    <div class="mode-tabs" *ngIf="hasPresetReasons">
        <button
            class="mode-tab"
            [class.active]="mode === 'preset'"
            (click)="setMode('preset')">
            {{ data.body.presetTab }}
        </button>
        <button
            class="mode-tab"
            [class.active]="mode === 'custom'"
            (click)="setMode('custom')">
            {{ data.body.customTab }}
        </button>
    </div>

    <div class="reasons-list" *ngIf="mode === 'preset' && hasPresetReasons">
        <button
            *ngFor="let reason of data.denialReasons"
            class="reason-card"
            [class.selected]="isSelected(reason.id)"
            (click)="toggleReason(reason.id)">
            <p class="reason-title">{{ reason.title }}</p>
            <p class="reason-description">{{ reason.citizenReason }}</p>
        </button>
    </div>

    <!-- Custom text input -->
    <form [formGroup]="requestDenyForm" *ngIf="mode === 'custom'">
        <app-form-textarea
            label="{{ data.body.label }}"
            placeholder="{{ data.body.placeholder }}"
            formControlName="reason">
            <app-form-error *ngIf="reason.touched && reason.hasError('required')">
                {{ data.body.error}}
            </app-form-error>
        </app-form-textarea>
    </form>
</div>

<footer>
    <button
        class="bciti-button bciti-button--blue"
        [disabled]="!canSubmit"
        (click)="submit()">
        {{ data.body.button }}
    </button>
</footer>
